import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { createUseStyles, useTheme } from "react-jss";
var Lockedstyles = {
  Artiweb_Icon_Svg: {
    display: 'block'
  }
};
var styles = createUseStyles(function (theme) {
  return {
    Artiweb_Icon_Svg: {
      transition: 'transform',
      transitionDuration: function transitionDuration(props) {
        return props.SVGTransitionDurationRotate ? props.SVGTransitionDurationRotate + 'ms' : theme.ArtiWebIcons.Artiweb_Icon_Svg.transitionDuration;
      },
      transitionTimingFunction: function transitionTimingFunction(props) {
        return props.SVGTransitionRotateEasing ? props.SVGTransitionRotateEasing : theme.ArtiWebIcons.Artiweb_Icon_Svg.transitionTimingFunction;
      },
      '&:hover $Artiweb_Icon_Main': {
        fill: function fill(props) {
          return props.SVGFillHoverColor ? props.SVGFillHoverColor : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverMain.fill;
        },
        stroke: function stroke(props) {
          return props.SVGStrokeHoverColor ? props.SVGStrokeHoverColor : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverMain.stroke;
        },
        transition: function transition(props) {
          return ["fill ".concat(props.SVGTransitionDurationHover ? props.SVGTransitionDurationHover + 'ms' : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverMain.transitionDuration, " ").concat(props.SVGTransitionHoverEasing ? props.SVGTransitionHoverEasing : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverMain.transitionTimingFunction), "stroke ".concat(props.SVGTransitionDurationHover ? props.SVGTransitionDurationHover + 'ms' : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverMain.transitionDuration, " ").concat(props.SVGTransitionHoverEasing ? props.SVGTransitionHoverEasing : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverMain.transitionTimingFunction)];
        }
      },
      '&:hover $Artiweb_Icon_Frame': {
        fill: function fill(props) {
          return props.FrameFillColorHover ? props.FrameFillColorHover : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverFrame.fill;
        },
        stroke: function stroke(props) {
          return props.FrameStrokeColorHover ? props.FrameStrokeColorHover : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverFrame.stroke;
        },
        transition: function transition(props) {
          return ["fill ".concat(props.SVGTransitionDurationHover ? props.SVGTransitionDurationHover + 'ms' : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverFrame.transitionDuration, " ").concat(props.SVGTransitionHoverEasing ? props.SVGTransitionHoverEasing : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverFrame.transitionTimingFunction), "stroke ".concat(props.SVGTransitionDurationHover ? props.SVGTransitionDurationHover + 'ms' : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverFrame.transitionDuration, " ").concat(props.SVGTransitionHoverEasing ? props.SVGTransitionHoverEasing : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverFrame.transitionTimingFunction)];
        }
      }
    },
    Artiweb_Icon_Main: {
      fill: function fill(props) {
        return props.SVGFillColor ? props.SVGFillColor : theme.ArtiWebIcons.Artiweb_Icon_Main.fill;
      },
      stroke: function stroke(props) {
        return props.SVGStrokeColor ? props.SVGStrokeColor : theme.ArtiWebIcons.Artiweb_Icon_Main.stroke;
      },
      strokeWidth: function strokeWidth(props) {
        return props.SVGStrokeWidth ? props.SVGStrokeWidth : theme.ArtiWebIcons.Artiweb_Icon_Main.strokeWidth;
      },
      transition: function transition(props) {
        return ["fill ".concat(props.SVGTransitionDurationHover ? props.SVGTransitionDurationHover + 'ms' : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverMain.transitionDuration, " ").concat(props.SVGTransitionHoverEasing ? props.SVGTransitionHoverEasing : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverMain.transitionTimingFunction), "stroke ".concat(props.SVGTransitionDurationHover ? props.SVGTransitionDurationHover + 'ms' : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverMain.transitionDuration, " ").concat(props.SVGTransitionHoverEasing ? props.SVGTransitionHoverEasing : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverMain.transitionTimingFunction)];
      }
    },
    Artiweb_Icon_Frame: {
      fill: function fill(props) {
        return props.FrameFillColor ? props.FrameFillColor : theme.ArtiWebIcons.Artiweb_Icon_Frame.fill;
      },
      stroke: function stroke(props) {
        return props.FrameStrokeColor ? props.FrameStrokeColor : theme.ArtiWebIcons.Artiweb_Icon_Frame.stroke;
      },
      strokeWidth: function strokeWidth(props) {
        return props.FrameStrokeWidth ? props.FrameStrokeWidth : theme.ArtiWebIcons.Artiweb_Icon_Frame.strokeWidth;
      },
      transition: function transition(props) {
        return ["fill ".concat(props.SVGTransitionDurationHover ? props.SVGTransitionDurationHover + 'ms' : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverFrame.transitionDuration, " ").concat(props.SVGTransitionHoverEasing ? props.SVGTransitionHoverEasing : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverFrame.transitionTimingFunction), "stroke ".concat(props.SVGTransitionDurationHover ? props.SVGTransitionDurationHover + 'ms' : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverFrame.transitionDuration, " ").concat(props.SVGTransitionHoverEasing ? props.SVGTransitionHoverEasing : theme.ArtiWebIcons.Artiweb_Icon_Svg.hoverFrame.transitionTimingFunction)];
      }
    },
    Specific_Class: {
      fill: function fill(props) {
        return props.SVGFillColor ? props.SVGFillColor : theme[props.InputClass] ? theme[props.InputClass].fill : void 0;
      },
      stroke: function stroke(props) {
        return props.SVGStrokeColor ? props.SVGStrokeColor : theme[props.InputClass] ? theme[props.InputClass].stroke : void 0;
      },
      strokeWidth: function strokeWidth(props) {
        return props.SVGStrokeWidth ? props.SVGStrokeWidth : theme[props.InputClass] ? theme[props.InputClass].strokeWidth : void 0;
      }
    }
  };
});
var viewBox = '0 0 100 100';
/**
 * SvgIcon is a React Wrapper for an SVG ICon. It takes the SVG code and create a React Component from it.
 * Note that it requires a specific SVG structure to automatically Generate the name, categories and the ts file attached to it.
 * It has mutliple options to easily configure the icon as props or using a css template that will be applie to all icons in your app
 */

var SvgIcon = /*#__PURE__*/React.forwardRef(function SvgIcon(props, ref) {
  var theme = useTheme();
  var classes = styles(_extends({}, props, {
    theme: theme
  }));

  var IconSize = props.IconSize,
      SVGFillColor = props.SVGFillColor,
      SVGStrokeColor = props.SVGStrokeColor,
      SVGStrokeWidth = props.SVGStrokeWidth,
      SVGStrokeHoverColor = props.SVGStrokeHoverColor,
      SVGFillHoverColor = props.SVGFillHoverColor,
      Frame = props.Frame,
      FrameStrokeWidth = props.FrameStrokeWidth,
      FrameStrokeColor = props.FrameStrokeColor,
      FrameFillColor = props.FrameFillColor,
      FrameStrokeColorHover = props.FrameStrokeColorHover,
      FrameFillColorHover = props.FrameFillColorHover,
      InnerPadding = props.InnerPadding,
      Rotate = props.Rotate,
      SVGTransitionDurationHover = props.SVGTransitionDurationHover,
      SVGTransitionHoverEasing = props.SVGTransitionHoverEasing,
      SVGTransitionDurationRotate = props.SVGTransitionDurationRotate,
      SVGTransitionRotateEasing = props.SVGTransitionRotateEasing,
      InputClass = props.InputClass,
      children = props.children,
      other = _objectWithoutProperties(props, ["IconSize", "SVGFillColor", "SVGStrokeColor", "SVGStrokeWidth", "SVGStrokeHoverColor", "SVGFillHoverColor", "Frame", "FrameStrokeWidth", "FrameStrokeColor", "FrameFillColor", "FrameStrokeColorHover", "FrameFillColorHover", "InnerPadding", "Rotate", "SVGTransitionDurationHover", "SVGTransitionHoverEasing", "SVGTransitionDurationRotate", "SVGTransitionRotateEasing", "InputClass", "children"]);

  var FinalIconSize = IconSize ? IconSize : theme.ArtiWebIcons.IconSize;
  var InnerPaddingNumber = InnerPadding ? parseFloat(InnerPadding) : parseFloat(theme.ArtiWebIcons.InnerPadding);
  var FinalFrameStrokeWidth = FrameStrokeWidth ? FrameStrokeWidth : theme.ArtiWebIcons.Artiweb_Icon_Frame.strokeWidth;
  var FinalFrame = Frame ? Frame : theme.ArtiWebIcons.Frame;
  var CreateFrame, transform, ViewBoxWidth, ViewBoxHeight, Translate;

  if (FinalFrame === 'circle') {
    //Circle Frame
    var mypadding = InnerPaddingNumber;
    Translate = parseFloat(FinalFrameStrokeWidth) + mypadding;
    ViewBoxWidth = 100 + 2 * (InnerPaddingNumber + parseFloat(FinalFrameStrokeWidth));
    ViewBoxHeight = 100 + 2 * (InnerPaddingNumber + parseFloat(FinalFrameStrokeWidth));
    CreateFrame = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
      className: classes.Artiweb_Icon_Frame,
      cx: 50 + mypadding + parseFloat(FinalFrameStrokeWidth),
      cy: 50 + mypadding + parseFloat(FinalFrameStrokeWidth),
      r: 50 + mypadding,
      fill: FrameFillColor,
      strokeWidth: parseFloat(FinalFrameStrokeWidth),
      stroke: FrameStrokeColor
    }));
    viewBox = "0 0 ".concat(ViewBoxWidth, " ").concat(ViewBoxHeight);
    transform = "translate(".concat(Translate, ",").concat(Translate, ")");
  } else if (FinalFrame === 'rounded') {
    //Rounded Frame
    ViewBoxWidth = 100 + 2 * (InnerPaddingNumber + parseFloat(FinalFrameStrokeWidth));
    ViewBoxHeight = 100 + 2 * (InnerPaddingNumber + parseFloat(FinalFrameStrokeWidth));
    Translate = InnerPaddingNumber + parseFloat(FinalFrameStrokeWidth);
    CreateFrame = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
      className: classes.Artiweb_Icon_Frame,
      x: parseFloat(FinalFrameStrokeWidth) / 2,
      y: parseFloat(FinalFrameStrokeWidth) / 2,
      width: ViewBoxWidth - parseFloat(FinalFrameStrokeWidth),
      height: ViewBoxHeight - parseFloat(FinalFrameStrokeWidth),
      rx: "10"
    }));
    viewBox = "0 0 ".concat(ViewBoxWidth, " ").concat(ViewBoxHeight);
    transform = "translate(".concat(Translate, ",").concat(Translate, ")");
  } else if (FinalFrame === 'square') {
    //Square Frame
    ViewBoxWidth = 100 + 2 * (InnerPaddingNumber + parseFloat(FinalFrameStrokeWidth));
    ViewBoxHeight = 100 + 2 * (InnerPaddingNumber + parseFloat(FinalFrameStrokeWidth));
    Translate = InnerPaddingNumber + parseFloat(FinalFrameStrokeWidth);
    CreateFrame = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
      className: classes.Artiweb_Icon_Frame,
      strokeWidth: FinalFrameStrokeWidth,
      stroke: FrameStrokeColor,
      x: parseFloat(FinalFrameStrokeWidth) / 2,
      y: parseFloat(FinalFrameStrokeWidth) / 2,
      width: ViewBoxWidth - parseFloat(FinalFrameStrokeWidth),
      height: ViewBoxWidth - parseFloat(FinalFrameStrokeWidth)
    }));
    viewBox = "0 0 ".concat(ViewBoxWidth, " ").concat(ViewBoxHeight);
    transform = "translate(".concat(Translate, ",").concat(Translate, ")");
  } else {
    //No Frame
    ViewBoxWidth = 100 + InnerPaddingNumber;
    ViewBoxHeight = 100 + InnerPaddingNumber;
    Translate = InnerPaddingNumber / 2;
    viewBox = "0 0 ".concat(ViewBoxWidth, " ").concat(ViewBoxHeight);
    transform = "translate(".concat(Translate, ",").concat(Translate, ")");
  }

  var OutputFrame;

  if (FinalFrame === 'none') {
    OutputFrame = "rotate(".concat(Rotate, "deg)");
  } else {
    OutputFrame = 'rotate(0deg)';
  }

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref
  }, other, {
    className: classes.Artiweb_Icon_Svg,
    shapeRendering: "geometricPrecision",
    width: FinalIconSize //   transform-origin="55 55"
    ,
    style: _extends({}, Lockedstyles.Artiweb_Icon_Svg, {
      transform: OutputFrame
    }),
    height: FinalIconSize,
    viewBox: viewBox,
    x: "0px",
    y: "0px"
  }), CreateFrame, /*#__PURE__*/React.createElement("g", {
    className: clsx(classes.Artiweb_Icon_Main, classes.Specific_Class),
    transform: transform
  }, children));
});
SvgIcon.defaultProps = {
  IconSize: null,
  SVGFillColor: null,
  SVGStrokeColor: null,
  SVGStrokeWidth: null,
  SVGStrokeHoverColor: null,
  SVGFillHoverColor: null,
  InnerPadding: null,
  Rotate: 0,
  Frame: null,
  FrameStrokeWidth: null,
  FrameStrokeColor: null,
  FrameFillColor: null,
  FrameStrokeColorHover: null,
  FrameFillColorHover: null,
  SVGTransitionDurationHover: null,
  SVGTransitionHoverEasing: null,
  SVGTransitionDurationRotate: null,
  SVGTransitionRotateEasing: null
};
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
  /**
   * The width and height the SVG Icon
   */
  IconSize: PropTypes.any,

  /**
   * The fill color of the svg if the property is allowed any html color code can be used
   */
  SVGFillColor: PropTypes.any,

  /**
   * The stroke color of the svg if the property is allowed any html color code can be used
   */
  SVGStrokeColor: PropTypes.any,

  /**
   * The stroke-width property of the SVG Icon if the property is allowed
   */
  SVGStrokeWidth: PropTypes.any,

  /**
   * The Hover stroke color of the svg if the property is allowed any html color code can be used
   */
  SVGStrokeHoverColor: PropTypes.any,

  /**
   * The Hover Fill color of the svg if the property is allowed any html color code can be used
   */
  SVGFillHoverColor: PropTypes.any,

  /**
   * The padding betweend the viewbox and the svg path if no frame or the padding between the frame and the svg path when using a frame
   */
  InnerPadding: PropTypes.any,

  /**
   * The rotatation angle of the svg path. Negative angles can be used. This is only available with no frame
   */
  Rotate: PropTypes.any,

  /**
   * The type of frame to be used
   */
  Frame: PropTypes.oneOf(['none', 'rounded', 'square', 'circle']),

  /**
   * The stroke-width of the frame
   */
  FrameStrokeWidth: PropTypes.any,

  /**
   * The stroke color of the frame. Any html color code can be used
   */
  FrameStrokeColor: PropTypes.any,

  /**
   * The fill color of the frame. Any html color code can be used
   */
  FrameFillColor: PropTypes.any,

  /**
   * The hover stroke color of the frame. Any html color code can be used
   */
  FrameStrokeColorHover: PropTypes.any,

  /**
   * The hover fill color of the frame. Any html color code can be used
   */
  FrameFillColorHover: PropTypes.any,

  /**
   * The duration of the hover transition no units but using (ms)
   */
  SVGTransitionDurationHover: PropTypes.any,

  /**
   * The easing property for the hover transition
   */
  SVGTransitionHoverEasing: PropTypes.any,

  /**
   * The duration of the rotation transition no units but using (ms)
   */
  SVGTransitionDurationRotate: PropTypes.any,

  /**
   * The easing property for the rotation transition
   */
  SVGTransitionRotateEasing: PropTypes.any
} : void 0;
export default SvgIcon;